import 'core-js/proposals/reflect-metadata';
import 'zone.js';
// other
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInstance, Piral } from 'piral-core';
import { Dashboard } from 'piral-dashboard';
import { storage } from 'piral-core';
import { KeycloakProvider, useKeycloak } from './keycloak-api';
import { Loading } from './components/Loading/Loading';
import { getPlugins } from './plugins';
import { components } from './components/Layout/Layout';
import { errorComponents } from './components/Errors/Errors';

const AuthorizedApp = () => {
  const { keycloak, loading } = useKeycloak();

  React.useEffect(() => {
    const handleDropDownClick = (event: PointerEvent) => {
      if (!(event.target instanceof Element)) return;
      let clickedMenu = event.target.closest('.neo-dropdown-menu');

      if (!clickedMenu) {
        document.querySelectorAll('.neo-dropdown-menu.open').forEach(menu => menu.classList.remove('open'));
        return;
      }
      if (clickedMenu.classList.contains('open')) {
        clickedMenu.classList.remove('open');
      } else {
        document.querySelectorAll('.neo-dropdown-menu.open').forEach(menu => menu.classList.remove('open'));
        clickedMenu.classList.add('open');
      }
    };

    document.addEventListener('click', handleDropDownClick);
    return () => {
      document.removeEventListener('click', handleDropDownClick);
    };
  }, []);

  if (loading) {
    return <Loading />;
  }

  // Sprache kommt von keycloak und wird einmalig gesetzt
  let locale: string = keycloak.idTokenParsed?.['locale'];
  if (!locale) {
    locale = navigator.language ?? 'de';
    if (locale.indexOf('-') > 0) {
      locale = locale.substring(0, locale.indexOf('-'));
    }
  }
  storage.setItem('locale', locale);

  const appInstance = createInstance({
    plugins: getPlugins(),
    requestPilets: () => {
      const feedUrl = keycloak.authServerUrl.includes('keycloak.dev.sip.de') ? '/devfeed' : '/feed';
      return fetch(feedUrl, {
        headers: {
          Authorization: `Bearer ${keycloak.token}`,
        },
      })
        .then(res => res.json())
        .then(res => res.items);
    },
    state: {
      components,
      errorComponents,
      routes: {
        '/': Dashboard,
      },
    },
  });
  (window as any).keycloakGetIdToken = () => {
    return JSON.stringify(keycloak.idTokenParsed);
  };

  (window as any).keycloakGetAccessToken = () => {
    return keycloak.token;
  };

  return <Piral instance={appInstance} />;
};

const App = () => {
  return (
    <KeycloakProvider>
      <React.Suspense fallback={<Loading />}>
        <AuthorizedApp />
      </React.Suspense>
    </KeycloakProvider>
  );
};

const root = createRoot(document.querySelector('#app'));
root.render(<App />);
